import Vue from 'vue'
import Router from 'vue-router'

//各模块定义
import HomeRouter from './home'
import Control from './control'
import errorPage from './errorPage'
import plugin from './plugin'
import golddata from './goldData'
import statistics from "./statistics";

Vue.use(Router)

const Rout = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['../view/login/login'], resolve)
    },

    {
      path: '/login/:id',
      meta: {
        keepAlive: true,
        pathName: 'login'
      },
      component: resolve => require(['../view/loginBack/loginBack'], resolve),
      children: [
        {
          path: '/noticeMsg',
          meta: {
            keepAlive: false,
            pathName: 'noticeMsg'
          },
          component: resolve => require(['../view/notice_msg/notice_msg'], resolve)
        },
        {
          path: '/shop_staff',
          meta: {
            keepAlive: true,
            pathName: 'shop_staff'
          },
          component: resolve => require(['../view/control/shop-staff'], resolve)
        },
        ...HomeRouter,
        ...Control,
        ...plugin,
        ...golddata,
        ...statistics
      ]
    },
    ...errorPage
  ]
})

Rout.beforeEach((to, from, next) => {
  document.getElementById('allLoadingBox').style.display = 'block'
  next()
})

Rout.afterEach((to, from) => {
  document.getElementById('allLoadingBox').style.display = 'none'
  if (to.name === 'login' && from.meta.pathName) {
    window.location.reload()
  }
})

export default Rout



// WEBPACK FOOTER //
// ./src/router/index.js